import Parvus = require('parvus')

// let next = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 24" class="arrow arrow--right">
// <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.8 12h40.4m0 0L36 20.2m8.2-8.2L36 3.8"/>
// </svg>`

let next = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 9 15" class="arrow arrow--right">
<path stroke-linecap="square" stroke-width="2" d="m1.8 2 5.9 5.8-5.9 5.9"/>
</svg>`

let prev = `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 15" class="arrow arrow--left">
  <path stroke-linecap="square" stroke-width="2" d="M7.8 2 2 7.8l5.8 5.9"/>
</svg>
`

// let prev = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 24" class="arrow arrow--left">
// <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M44.2 12H3.8m0 0 8.2 8.2M3.8 12 12 3.8"/>
// </svg>`

export function initLightbox() {
    const prvs = new Parvus({
        selector: '.projects-gallery',
        lightboxIndicatorIcon: '',
        nextButtonIcon: next,
        previousButtonIcon: prev,
    })
}
